import { useCallback, useState } from 'react'
import { showAlert } from '../../utility/SweetAlert'
import ApiService from '../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { TIMEOUT_DURATION_CHECKEMAIL_RFQ } from '../../constant/global/Config'

const InteractorRfqFormAction = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { account } = useSelector((state) => state.account)
  const { seller } = useSelector((state) => state.seller)
  const [buyerAccount, setBuyerAccount] = useState({})

  const rfqCreate = useCallback(
    (payload, setLoading = () => {}) => {
      const requestPayload = {
        ...payload,
        store_uid: seller.uid,
        created_by: account.full_name,
      }
      setLoading(true)
      ApiService.jsonRequest('/rfq-quotation/create', requestPayload, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.offer_has_been_sent`),
            timer: false,
          })
          navigate('/rfq')
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.full_name, navigate, seller.uid, t],
  )

  const rfqUpdate = useCallback(
    (payload, callback = () => {}, setLoading = () => {}) => {
      const requestPayload = {
        ...payload,
        updated_by: account.full_name,
      }
      setLoading(true)
      ApiService.jsonRequest('/rfq-quotation/update', requestPayload, (response) => {
        setLoading(false)
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t(`response_message.data_has_been_updated`),
            timer: false,
          })
          callback()
          navigate('/rfq')
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: false,
          })
        }
      })
    },
    [account.full_name, navigate, t],
  )

  const rfqCheckEmail = useCallback(
    (payload, callback = () => {}, setLoading = () => {}) => {
      const requestPayload = { ...payload }
      setLoading(true)
      const timeout = setTimeout(() => {
        setLoading(false)
        showAlert({
          icon: 'error',
          message: t('response_message.internet_connection_error'),
          timer: false,
        })
      }, TIMEOUT_DURATION_CHECKEMAIL_RFQ)

      ApiService.jsonRequest('/account-user/verify-email', requestPayload, (response) => {
        clearTimeout(timeout)
        setLoading(false)

        if (response.status_code === 200) {
          callback(response.data)
        } else {
          const errorMessage =
            response.messages === 'data_not_exist'
              ? t('response_message.email_not_found_on_system')
              : t(`response_message.${response.messages}`)
          showAlert({
            icon: 'error',
            message: errorMessage,
            timer: false,
          })
        }
      })
    },
    [t],
  )

  return {
    buyerAccount,
    rfqCheckEmail,
    rfqCreate,
    rfqUpdate,
    setBuyerAccount,
  }
}

export default InteractorRfqFormAction
